/**
 * abilityVfxVeigar — Veigar Q/W/E/R void silhouettes (SPY-212).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildBalefulStrike(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const voidC = mat(THREE, spec.color || 0x7c3aed);
  const glow = mat(THREE, 0xc4b5fd);
  const bolt = new THREE.Mesh(new THREE.BoxGeometry(0.18 * s, 0.18 * s, 1.1 * s), voidC);
  bolt.position.y = 0.45 * s;
  group.add(bolt);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.35 * s, 6), glow);
  tip.position.set(0, 0.45 * s, 0.65 * s);
  tip.rotation.x = Math.PI / 2;
  group.add(tip);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), glow);
  spark.position.set(0, 0.55 * s, -0.4 * s);
  group.add(spark);
  group.userData = { shape: 'baleful_strike' };
  return group;
}

export function buildDarkMatter(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.5);
  const voidC = mat(THREE, spec.color || 0x5b21b6, 0.9);
  const rim = mat(THREE, 0xa78bfa, 0.8);
  const rock = new THREE.Mesh(new THREE.SphereGeometry(0.4 * s, 10, 8), voidC);
  rock.position.y = 1.1 * s;
  group.add(rock);
  const crater = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.9 * s, 20).rotateX(-Math.PI / 2),
    rim
  );
  crater.position.y = 0.05;
  group.add(crater);
  const shard = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.4 * s, 5), rim);
  shard.position.set(0.35 * s, 0.35 * s, 0);
  group.add(shard);
  group.userData = { shape: 'dark_matter' };
  return group;
}

export function buildEventHorizon(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.75 * (spec.scale || 1.6);
  const voidC = mat(THREE, spec.color || 0x4c1d95, 0.85);
  const edge = mat(THREE, 0xddd6fe, 0.9);
  const ring = new THREE.Mesh(
    new THREE.TorusGeometry(0.7 * s, 0.08 * s, 8, 24),
    voidC
  );
  ring.rotation.x = Math.PI / 2;
  ring.position.y = 0.2;
  group.add(ring);
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(0.75 * s, 0.95 * s, 24).rotateX(-Math.PI / 2),
    edge
  );
  outer.position.y = 0.06;
  group.add(outer);
  const hub = new THREE.Mesh(new THREE.SphereGeometry(0.15 * s, 8, 8), edge);
  hub.position.y = 0.25;
  group.add(hub);
  group.userData = { shape: 'event_horizon' };
  return group;
}

export function buildPrimordialBurst(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.5);
  const voidC = mat(THREE, spec.color || 0x6d28d9, 0.92);
  const core = mat(THREE, 0xf5d0fe, 0.95);
  const blast = new THREE.Mesh(new THREE.SphereGeometry(0.45 * s, 12, 12), voidC);
  blast.position.y = 0.55 * s;
  group.add(blast);
  const nucleus = new THREE.Mesh(new THREE.SphereGeometry(0.18 * s, 10, 10), core);
  nucleus.position.y = 0.55 * s;
  group.add(nucleus);
  const halo = new THREE.Mesh(
    new THREE.RingGeometry(0.4 * s, 0.7 * s, 18).rotateX(-Math.PI / 2),
    voidC
  );
  halo.position.y = 0.08;
  group.add(halo);
  group.userData = { shape: 'primordial_burst' };
  return group;
}
